import {  useState } from "react";
import { BASE_URL } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AxiosError } from "axios";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";
import { TypeSellingData } from "../pages/selling/CreateSellingPage";

const useSellingData = () => {
  const [loadingData, setLoadingData] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const [sellingData, setSellingData] = useState<TypeSellingData[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();

  const getSellingData = async () => {
    setLoadingData(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/marketing",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingData(false);
        setSellingData(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingData(false);
      });
  };

  return { loadingData, sellingData, getSellingData };
};

export default useSellingData;
